import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
var moment = require('moment');
import { Item } from './Item';

import { Form, Errors, LocalForm, Control, actions, Field } from 'react-redux-form';
import { required, maxLength, email, minLength } from "../../Validators/";
import {
  updateOn,
  validateOn,
  mapProps,
  showErrors
} from "../../Controls/ReactReduxFormSettings";

@withRouter
export class NotificationList extends React.Component<any, any> {
    constructor(props) {
        super(props);
        var notificationFrequencyDays = this.props.currentUser ? this.props.currentUser.notificationFrequencyDays : 7;
        var notificationImmediate = this.props.currentUser ? this.props.currentUser.notificationImmediate ? "1" : "0" : "1";
        this.state = {notificationFrequencyDays: notificationFrequencyDays, notificationImmediate: notificationImmediate}
        this.onFrequencyChanged = this.onFrequencyChanged.bind(this);
        this.onNotificationChanged = this.onNotificationChanged.bind(this);
    }

    onNotificationChanged(event){
        this.props.updateNotification(event.target.value);
    }

    onFrequencyChanged(event){
        this.props.updateEmailFrequency(event.target.value);
    }

    render() {
        const { forum } = this.props;
        var notifications = forum ? forum.notifications.map((n, i) => {
            return <Item key={i} item={n} {...this.props}/> ;
        }) : undefined;
        return (<div className="col-12 col-md-9">
                    <div className="row">
                        <div className="col col-12 col-lg-3">
                            <h4>Notifications</h4>
                        </div>
                        <div className="col-12 col-lg-9">
                            <LocalForm model="settings">
                                <div className="form-inline pull-right">
                                    <label className="mx-2">Live updates: </label>
                                    <Control.select model=".notification"
                                                defaultValue={this.state.notificationImmediate} 
                                                onChange={this.onNotificationChanged}
                                                className="form-control"
                                                validators={{
                                                    required: required
                                                }}
                                                updateOn={updateOn}
                                                validateOn={validateOn}>
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                    </Control.select>
                                    <label className="mx-2">Summary updates:</label>
                                    <Control.select model=".frequency" className="form-control"
                                                onChange={this.onFrequencyChanged}
                                                defaultValue={this.state.notificationFrequencyDays} 
                                                validators={{
                                                    required: required
                                                }}
                                                updateOn={updateOn}
                                                validateOn={validateOn}>
                                        <option value={7}>Weekly</option>
                                        <option value={14}>Fortnightly</option>
                                        <option value={30}>Monthly</option>
                                        <option value={0}>Never</option>
                                    </Control.select>
                            </div>
                            </LocalForm>
                        </div>
                        <div className={`col-12 discussion-board-resource card mt-0 mb-3`} >
                            <hr/>
                            {notifications}
                        </div>
                    </div>
                </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Notifications/List.tsx